var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58153 0 0 3.5816 0 8C0 12.4184 3.5816 16 8 16C12.4184 16 16 12.4184 16 8C16 3.5816 12.4184 0 8 0ZM11.3951 5.19506L8.9876 7.602C9.03731 7.72513 9.06685 7.85905 9.06685 8.00007C9.06685 8.58917 8.58908 9.0665 8.00042 9.0665C7.41177 9.0665 6.934 8.58873 6.934 8.00007C6.934 7.85891 6.96297 7.72541 7.01268 7.602L3.92204 4.51136C3.75915 4.34846 3.75915 4.08475 3.92204 3.9214C4.08494 3.75807 4.34866 3.7585 4.51157 3.9214L7.60265 7.01247C7.72578 6.96276 7.8597 6.93322 8.00072 6.93322C8.14189 6.93322 8.27539 6.9622 8.39879 7.01247L10.8057 4.60494C10.9686 4.44205 11.2324 4.44205 11.3957 4.60494C11.5595 4.76798 11.558 5.0317 11.3951 5.19502L11.3951 5.19506Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.d6911faaaf4783c65f40947f4b213c1d.svg";
export { ForwardRef as ReactComponent };